export const REDUCER_KEY_RS = 'rs';
export const REDUCER_KEY_PROJECT_LIST = 'projectsList';

export const FETCH_PROJECTS = 'rs/FETCH_PROJECTS';
export const FETCH_PROJECTS_SUCCESS = 'rs/FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_FAILURE = 'rs/FETCH_PROJECTS_FAILURE';

export const PROJECTS_STATUSES_UPDATED = 'rs/PROJECTS_STATUSES_UPDATED';

export const ADD_PROJECT = 'rs/ADD_PROJECT';
export const ADD_PROJECT_SUCCESS = 'rs/ADD_PROJECT_SUCCESS';
export const ADD_PROJECT_FAILURE = 'rs/ADD_PROJECT_FAILURE';
export const IMPORT_PROJECTS = 'rs/IMPORT_PROJECTS';
export const IMPORT_PROJECTS_SUCCESS = 'rs/IMPORT_PROJECTS_SUCCESS';
export const CLEAR_IMPORTED_PROJECTS = 'rs/CLEAR_IMPORTED_PROJECTS';

export const RENAME_PROJECT = 'rs/RENAME_PROJECT';
export const RENAME_PROJECT_SUCCESS = 'rs/RENAME_PROJECT_SUCCESS';
export const RENAME_PROJECT_FAILURE = 'rs/RENAME_PROJECT_FAILURE';

export const DELETE_PROJECT = 'rs/DELETE_PROJECT';
export const DELETE_PROJECT_SUCCESS = 'rs/DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_FAILURE = 'rs/DELETE_PROJECT_FAILURE';

export const PROJECTS_CLEAR_STATE = 'rs/PROJECTS_CLEAR_STATE';

export const EDIT_PROJECT = 'rs/EDIT_PROJECT';
export const CLEAR_EDIT_PROJECT = 'rs/CLEAR_EDIT_PROJECT';

export const CLEAR_CREATED_PROJECT = 'rs/CLEAR_CREATED_PROJECT';
export const SET_VIEW_PROJECTS_POSITION = 'rs/SET_VIEW_PROJECTS_POSITION';

export const RETRY_PROJECT = 'rs/RETRY_PROJECT';
export const RETRY_PROJECT_SUCCESS = 'rs/RETRY_PROJECT_SUCCESS';
export const RETRY_PROJECT_FAILURE = 'rs/RETRY_PROJECT_FAILURE';

export const PROJECT_ACCESS_FAILURE_ERROR_NUMBER = 5;
export const PROJECT_ACCESS_FAILURE_STATUS_CODE = 400;

export const PROJECTS_LIST_DEFAULT_SIZE = 15;
export const PROJECTS_LIST_PAGE_SIZE_CACHE_KEY = 'rtProjectsPageSize';
